export interface IJob {
    id: string
    title: string
    firm: string
    jobType: string
    workType: undefined | "Uzaktan / Remote" | "Yüz yüze " | "Ofis"
    img?: string | undefined
    location: string
    sector: Sectors
}

export enum Sectors {
    AtikYonveGeriDon = "Atık Yön ve Geri Dön",
    Bilisim = "Bilişim",
    Danismanlik = "Danışmanlık",
    DayanikliTuketim = "Dayanıklı Tüketim",
    Denizcilik = "Denizcilik",
    Diger = "Diğer",
    Egitim = "Eğitim",
    Elektrik = "Elektrik",
    Enerji = "Enerji",
    Finans = "Finans",
    Gida = "Gıda",
    Guvenlik = "Güvenlik",
    Havacilik = "Havacılık",
    Hizmet = "Hizmet",
    HizliTuketim = "Hızlı Tüketim",
    Kimya = "Kimya",
    Maden = "Maden",
    Medya = "Medya",
    Otomotiv = "Otomotiv",
    Perakende = "Perakende",
    Saglik = "Sağlık",
    Sigortacilik = "Sigortacılık",
    Tarim = "Tarım",
    Tekstil = "Tekstil",
    Telekom = "Telekom",
    Ticaret = "Ticaret",
    Turizm = "Turizm",
    Uretim = "Üretim"
}

export const jobsDummy: IJob[] = [
    {
        id: "1",
        title: "Satış Temsilcisi",
        firm: "NTA İMPLANT",
        location: "Adana - Ankara",
        jobType: "Tam Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Ticaret
    },
    {
        id: "2",
        title: "Yazılım Geliştirici",
        firm: "Tech Solutions",
        location: "İstanbul",
        jobType: "Tam Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Bilisim
    },
    {
        id: "3",
        title: "Veri Bilimcisi",
        firm: "Data Experts",
        location: "Ankara",
        jobType: "Tam Zamanlı",
        workType: "Ofis",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Bilisim
    },
    {
        id: "4",
        title: "Sistem Yöneticisi",
        firm: "Network Solutions",
        location: "İzmir",
        jobType: "Tam Zamanlı",
        workType: "Ofis",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Bilisim
    },
    {
        id: "5",
        title: "Yazılım Test Mühendisi",
        firm: "Quality Assurance Inc.",
        location: "Bursa",
        jobType: "Tam Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Bilisim
    },
    {
        id: "6",
        title: "DevOps Mühendisi",
        firm: "Cloud Tech",
        location: "Antalya",
        jobType: "Tam Zamanlı",
        workType: "Ofis",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Bilisim
    },

    {
        id: "7",
        title: "Müşteri Hizmetleri Uzmanı",
        firm: "Global Call Center",
        location: "İzmir",
        jobType: "Yarı Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Hizmet
    },
    {
        id: "8",
        title: "Proje Yöneticisi",
        firm: "Creative Minds",
        location: "Ankara",
        jobType: "Tam Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Danismanlik
    },
    {
        id: "9",
        title: "Grafik Tasarımcı",
        firm: "Design Studio",
        location: "Bursa",
        jobType: "Freelance",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Medya
    },
    {
        id: "10",
        title: "Veri Analisti",
        firm: "Data Insights",
        location: "Antalya",
        jobType: "Tam Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Bilisim
    },
    {
        id: "11",
        title: "Pazarlama Uzmanı",
        firm: "Market Leaders",
        location: "Gaziantep",
        jobType: "Yarı Zamanlı",
        workType: "Uzaktan / Remote",
        img: "https://via.placeholder.com/150",
        sector: Sectors.Danismanlik
    }
];



